
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Ebene 2","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.48 1.5H.75A.76.76 0 010 .75.76.76 0 01.75 0h9.73a.76.76 0 01.75.75.76.76 0 01-.75.75zM23.25 1.5h-9.73a.76.76 0 01-.75-.75.76.76 0 01.75-.75h9.73a.76.76 0 01.75.75.76.76 0 01-.75.75zM23.25 9.88h-9.74a.75.75 0 01-.75-.76V4.65a.75.75 0 01.75-.75h9.74a.76.76 0 01.75.75v4.47a.76.76 0 01-.75.76zm-9-1.5h8.25v-3h-8.24z"}}),_c('path',{attrs:{"d":"M18.68 7.64h-2.3a.75.75 0 010-1.5h2.3a.75.75 0 010 1.5zM23.25 16.94h-9.74a.75.75 0 01-.75-.75v-4.48a.75.75 0 01.75-.75h9.74a.76.76 0 01.75.75v4.48a.76.76 0 01-.75.75zm-9-1.5h8.25v-3h-8.24z"}}),_c('path',{attrs:{"d":"M16.7 14.7h-.32a.75.75 0 010-1.5h.32a.75.75 0 010 1.5zM23.25 24h-9.74a.75.75 0 01-.75-.75v-4.48a.75.75 0 01.75-.75h9.74a.76.76 0 01.75.75v4.48a.76.76 0 01-.75.75zm-9-1.5h8.25v-3h-8.24z"}}),_c('path',{attrs:{"d":"M19.8 21.76h-3.42a.75.75 0 110-1.5h3.42a.75.75 0 010 1.5zM10.49 12.08H.75a.76.76 0 01-.75-.75V4.65a.76.76 0 01.75-.75h9.74a.75.75 0 01.75.75v6.68a.75.75 0 01-.75.75zm-9-1.5h8.25V5.4H1.5z"}}),_c('path',{attrs:{"d":"M7.6 7.64h-4a.75.75 0 010-1.5h4a.75.75 0 010 1.5zM4.39 9.84h-.77a.75.75 0 010-1.5h.77a.75.75 0 110 1.5zM10.49 19.14H.75a.75.75 0 01-.75-.75v-4.47a.75.75 0 01.75-.75h9.74a.74.74 0 01.75.75v4.47a.74.74 0 01-.75.75zm-9-1.5h8.25v-3H1.5z"}}),_c('path',{attrs:{"d":"M5.45 16.9H3.62a.75.75 0 010-1.5h1.83a.75.75 0 010 1.5z"}})])
          )
        }
      }
    